import { GridCellProps } from "@progress/kendo-react-grid";
import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { ProjectOverviewItem } from "./ProjectOverviewItem";
import { projectStateColumnMenu, ProjectStateEnumCell } from "./ProjectStateEnumCell";
import { defaultTimeFormatHHmmss } from "../../../Utils/dates";

export default function ProjectOverviewGridColumns({ onRowClick }: GridRowClickProps) {
  const projectStateEnumCell = (props: GridCellProps) =>
    ProjectStateEnumCell({ ...props, onRowClick });

  return [
    columnForField<ProjectOverviewItem>("ProjectId", {
      title: "Project No.",
      filter: "numeric",
      resizable: true,
    }),
    columnForField<ProjectOverviewItem>("ProjectReference", {
      title: "Project Ref.",
      resizable: true,
    }),
    columnForField<ProjectOverviewItem>("Name", {
      title: "Name",
      resizable: true,
    }),
    columnForField<ProjectOverviewItem>("StartDate", {
      title: "Start Date",
      resizable: true,
      cell: kendoDateCell(),
      filter: "date",
      width: "220px",
    }),
    columnForField<ProjectOverviewItem>("EndDate", {
      title: "End Date",
      resizable: true,
      cell: kendoDateCell(),
      filter: "date",
      width: "220px",
    }),
    columnForField<ProjectOverviewItem>("State", {
      title: "State",
      hideFilterCell: true,
      columnMenu: projectStateColumnMenu,
      resizable: true,
      cell: projectStateEnumCell,
    }),
    columnForField<ProjectOverviewItem>("Comment", {
      title: "Comment",
      resizable: true,
    }),
    columnForField<ProjectOverviewItem>("LastModifiedUser", {
      title: "Last Modified By",
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<ProjectOverviewItem>("LastModifiedDate", {
      title: "Last Modified Date",
      filter: "date",
      cell: kendoDateCell(onRowClick),
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<ProjectOverviewItem>("LastModifiedTime", {
      title: "Last Modified Time",
      resizable: true,
      width: defaultColumnWidth,
      cell: kendoDateCell(onRowClick, undefined, defaultTimeFormatHHmmss),
      hideFilterCell: true,
    }),
  ];
}
